import React, { useContext } from 'react';
import { shape, string } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Endcap } from '@thd-olt-component-react/endcap';
import { Card } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import {
  CUSTOMER_TYPES,
  getPersonalizedDealsUserId,
  MARKETING_CLOUD_VISITOR_ID_DEFAULT
} from '../../utils';
import { HomepageContext } from '../context/HomepageContext';

export function TopSavingsForYou({ store, id }) {
  const { storeId } = store;
  const { instance } = useContext(AppContext);
  const { thdSEOBotDetection: isBot } = instance;
  const { customerType } = useContext(HomepageContext);

  const personalizedUserId = isBot
    ? MARKETING_CLOUD_VISITOR_ID_DEFAULT
    : getPersonalizedDealsUserId(customerType);

  return (
    <ErrorBoundary name="endcap">
      <QueryProvider cacheKey="endcap">
        <Card
          className="sui-h-full"
          CardContentProps={{
            className: 'sui-h-full sui-flex sui-flex-col sui-w-full sui-gap-4 sui-p-4'
          }}
        >
          <Endcap
            channel="DESKTOP"
            customerType={customerType === CUSTOMER_TYPES.B2B ? 'B2B' : 'B2C'}
            pageUrl="/"
            storeId={storeId}
            personalizedDealsUserid={personalizedUserId}
            showLoading
            entryId={id}
            runQueryServerSide={!!isBot}
          />
        </Card>
      </QueryProvider>
    </ErrorBoundary>
  );
}

TopSavingsForYou.propTypes = {
  store: shape({
    storeId: string,
    storeZip: string,
  }),
  id: string,
};

TopSavingsForYou.defaultProps = {
  store: {
    storeId: '121',
    storeZip: '30339',
  },
  id: undefined,
};
